import React from "react";
import useStyles from "../styles";
import {
  Grid,
  Container,
  Typography,
  Button,
  Box,
  useMediaQuery,
} from "@material-ui/core";
import useSettingsAction from "../actions";

const AccountTab = () => {
  const classes = useStyles();
  const { openPwdChangeDialog, openDeactivateConfirmationDialog } =
    useSettingsAction();
  const matches = useMediaQuery((theme) => theme.breakpoints.up("sm"));
  return (
    <Container maxWidth="md">
      <Box m={1}>
        <Grid
          item
          container
          xs={12}
          justify="space-between"
          alignItems="center"
          className={classes.accountTab}
        >
          <Grid item container xs={12} sm={8} direction="column">
            <Typography variant="subtitle1">Password</Typography>
            <Typography variant="caption">
              Change password on your account
            </Typography>
          </Grid>
          <Grid
            item
            container
            xs={12}
            sm={4}
            justify={matches ? "flex-end" : "flex-start"}
            alignContent="center"
          >
            <Box my={2}>
              <Button
                variant="contained"
                color="primary"
                onClick={() => openPwdChangeDialog(true)}
              >
                Change
              </Button>
            </Box>
          </Grid>
        </Grid>
        <Grid
          item
          container
          xs={12}
          justify="space-between"
          alignItems="center"
          className={classes.accountTab}
        >
          <Grid item container xs={12} sm={8} direction="column">
            <Typography variant="subtitle1">Deactivation</Typography>
            <Typography variant="caption">Remove access to SVP</Typography>
          </Grid>
          <Grid
            item
            container
            xs={12}
            sm={4}
            justify={matches ? "flex-end" : "flex-start"}
            alignContent="center"
          >
            <Box my={2}>
              <Button
                variant="contained"
                color="primary"
                onClick={() => openDeactivateConfirmationDialog(true)}
              >
                Deactivate
              </Button>
            </Box>
          </Grid>
        </Grid>
      </Box>
    </Container>
  );
};
export default AccountTab;
